define([
	"dojo/_base/declare",
	"csi/heading/NumberController",
	"ProductSpec/SizeChart"
], function(declare,NumberController,SizeChart) {

	return declare(NumberController, {
		// Object: object with API for relevant size range information
		//_subSizeRanges: null,

		// Object: object with API for relevant size chart revision information
		//_sizeChartRevision: null,

		// If this SizeChart Dimension should display as two dimensional
		//_isDisplayTwoDim: null,

		//this.baseIndex: null,
		//baseSizeDim1Index: null,
		//baseSizeDim2Index: null,
		//dim1SizeCount: null,
		//dim2SizeCount: null,

		onStart: function() {
			var scDimension = this.getNode();
			this._subSizeRanges = this.widget.getSubSizeRangeData(scDimension);

			this._sizeChartRevision = this.widget.getSizeChartRevisionData(scDimension);
			if (this._sizeChartRevision && this._sizeChartRevision.isTwoDim()) {
				this._isDisplayTwoDim = this.widget.displayTwoDimension(scDimension);
				this.baseIndex = this._sizeChartRevision.baseIndex;
				this.baseSizeDim1Index = this._sizeChartRevision.getDim1BaseIndex();
				this.baseSizeDim2Index = this._sizeChartRevision.getDim2BaseIndex();
				this.dim1SizeCount = this._sizeChartRevision.getDim1SizeCount();
				this.dim2SizeCount = this._sizeChartRevision.getDim2SizeCount();
			}
		},

		_getBaseIndex: function(index) {
			// summary: returns base size index for the SizeChartDimension.
			// 1-d dimension on 2-d size chart, use dim1 base index.
			return this._sizeChartRevision.isTwoDim() && !this._isDisplayTwoDim ?
					this._sizeChartRevision.getDim1BaseIndex() :
						this._subSizeRanges.getBaseIndex(index);
		},

		_getMinIndex: function(index) {
			return this._sizeChartRevision.isTwoDim() && !this._isDisplayTwoDim ?
					0 : this._subSizeRanges.getMinIndex(index);
		},

		_getMaxIndex: function(index) {
			return this._sizeChartRevision.isTwoDim() && !this._isDisplayTwoDim ?
					this.dim1SizeCount -1 : this._subSizeRanges.getMaxIndex(index);
		},

		/**
		 * Get the index of the next non-blank, non-hole cell closer to the base size
		 * @param {integer} index
		 * @param {integer} baseIndex
		 * @param {Double[]} doubles
		 * @return {integer} - index of the next non-blank, non-hole cell closer to the base
		 */
		_getIndexOfValidCellCloserToBase: function(index, baseIndex, doubles) {
			if (this._isDisplayTwoDim) {
				// 2D SizeChartDimension
				var iResult;
				var x;
				var iDim1 = this._sizeChartRevision.getDim1Index(index);
				var iDim2 = this._sizeChartRevision.getDim2Index(index);
				if (iDim1 == this.baseSizeDim1Index) {
					// On base column : find next non-blank, non-hole cell vertically
					var y;
					if (iDim2 < this.baseSizeDim2Index) {
						for (y = iDim2 + 1; y <= this.baseSizeDim2Index; y++) {
							iResult = this._sizeChartRevision._mapDim1ToDim2Indices[iDim1][y];
							if (this._isValidIndex(iResult, doubles)) {
								return iResult;
							}
						}
					} else {
						for (y = iDim2 - 1; y >= this.baseSizeDim2Index; y--) {
							iResult = this._sizeChartRevision._mapDim1ToDim2Indices[iDim1][y];
							if (this._isValidIndex(iResult, doubles)) {
								return iResult;
							}
						}
					}

					// Use base size if no cell is found
					return this.baseIndex;
				} else if (iDim1 <= this.baseSizeDim1Index) {
					// Off base cell to the left : find valid cell horizontally toward the base
					for (x = iDim1 + 1; x <= this.baseSizeDim1Index; x++) {
						iResult = this._sizeChartRevision._mapDim1ToDim2Indices[x][iDim2];
						if (this._isValidIndex(iResult, doubles)) {
							return iResult;
						}
					}
				} else if (iDim1 >= this.baseSizeDim1Index) {
					// Off base cell to the right
					for (x = iDim1 - 1; x >= this.baseSizeDim1Index; x--) {
						iResult = this._sizeChartRevision._mapDim1ToDim2Indices[x][iDim2];
						if (this._isValidIndex(iResult, doubles)) {
							return iResult;
						}
					}
				}

				// Use base column if no cell is found
				return this._sizeChartRevision._mapDim1ToDim2Indices[this.baseSizeDim1Index][iDim2];
			} else {
				// 1D SizeChartDimension
				return (index > baseIndex)? index - 1 : index + 1;
			}
		},

		_getIndicesOfNextNonEmptyCellsAwayFromBase: function(/*Integer*/index, /*Integer*/baseIndex, /*Double[]*/doubles) {
			// Find the next non-blank increment and recalculate it to preserve the Relative/Absolute mode value

			var indices = [];

			if (this._isDisplayTwoDim) {
				// 2D SizeChartDimension
				var iDim1 = this._sizeChartRevision.getDim1Index(index);
				var iDim2 = this._sizeChartRevision.getDim2Index(index);
				var x;

				if (iDim1 == this.baseSizeDim1Index) {
					// On base column : 3 cells
					var y;

					// Next non-empty cell Vertically
					if (iDim2 < this.baseSizeDim2Index) {
						for (y = iDim2 - 1; y >= 0; y--) {
							if(this._checkAndPushTo(iDim1, y, doubles, indices))
								break;
						}
					} else {
						for (y = iDim2 + 1; y < this.dim2SizeCount; y++) {
							if(this._checkAndPushTo(iDim1, y, doubles, indices))
								break;
						}
					}
				}

				if (iDim1 <= this.baseSizeDim1Index) {
					// Cell to the left
					for (x = iDim1 - 1; x >= 0; x--) {
						if(this._checkAndPushTo(x, iDim2, doubles, indices))
							break;
					}
				}

				if (iDim1 >= this.baseSizeDim1Index) {
					// Cell to the right
					for (x = iDim1 + 1; x < this.dim1SizeCount; x++) {
						if(this._checkAndPushTo(x, iDim2, doubles, indices))
							break;
					}
				}
			} else {
				// 1D SizeChartDimension
				var	minIndex = this._getMinIndex(index);
				var	maxIndex = this._getMaxIndex(index);
				var i;

				if (index > baseIndex) {
					for (i = index +1; i<= maxIndex; i++) {
						if (!SizeChart.isNotInitialized(doubles[i])) {
							indices.push(i);
							break;
						}
					}
				} else if (index < baseIndex){
					for (i = index - 1; i>= minIndex; i--) {
						if (!SizeChart.isNotInitialized(doubles[i])) {
							indices.push(i);
							break;
						}
					}
				}
			}

			return indices;
		},

		_checkAndPushTo : function(/*Integer*/iDim1, /*Integer*/iDim2, /*Double[]*/doubles, /*Integer[]*/indices) {
			var i = this._sizeChartRevision._mapDim1ToDim2Indices[iDim1][iDim2];
			if (this._isValidIndex(i, doubles)) {
				indices.push(i)
				return true;
			}
			return false;
		},

		/**
		 * @param {integer} i
		 * @param {double[]} doubles
		 * @return {boolean} - if the input index is valid (not blank, not a hole)
		 */
		_isValidIndex : function(i, doubles) {
			return (i != undefined && i >= 0 && !SizeChart.isNotInitialized(doubles[i]));
		}
	});
});